import ApiNode from "./ApiNode";

export default {
  getSalesPersonWiseTeus(payload = {}) {
    return ApiNode().post("sales-person-client-map/get-salespersonwise-teus", payload);
  },
  
  // Sales Person Client Map APIs
  getAllSalesPersonClientMapsBak(params = {}) {
    return ApiNode().get("sales-person-client-map", { params });
  },
  
  upsertSalesPersonClientMap(payload = {}) {
    return ApiNode().post("sales-person-client-map", payload);
  },
  
  deleteSalesPersonClientMap(payload = {}) {
    return ApiNode().post("sales-person-client-map/remove", payload);
  },
  
  getSalesPersonClientMapById(spcMapId) {
    return ApiNode().get(`sales-person-client-map/${spcMapId}`);
  },
  
  getClientsBySalesPerson(userId) {
    return ApiNode().get(`sales-person-client-map/sales-person/${userId}/clients`);
  },
  
  getSalesPersonsByClient(clientId) {
    return ApiNode().get(`sales-person-client-map/client/${clientId}/sales-persons`);
  },
  
  // Bulk upload sales person client mappings
  bulkUploadSalesPersonClientMap(payload = {}) {
    return ApiNode().post("sales-person-client-map/bulk", payload);
  },

  // Get client wise TEUs details
  getClientWiseTeus(payload = {}) {
    return ApiNode().post("sales-person-client-map/client-wise-teus", payload);
  },

  // Get sales person dashboard data
  getSalesPersonDashboardData(payload = {}) {
    return ApiNode().post("sales-person-client-map/sales-person-dashboard", payload);
  },

  // Separate API endpoints for each tab with pagination
  getLeadsData(payload = {}) {
    return ApiNode().post("sales-person-client-map/leads", payload);
  },

  getEnquiriesData(payload = {}) {
    return ApiNode().post("sales-person-client-map/enquiries", payload);
  },

  getTopClientsData(payload = {}) {
    return ApiNode().post("sales-person-client-map/top-clients", payload);
  },

  getQuotationsData(payload = {}) {
    return ApiNode().post("sales-person-client-map/quotations", payload);
  },

  getAssignmentsData(payload = {}) {
    return ApiNode().post("sales-person-client-map/assignments", payload);
  },

  getBillingData(payload = {}) {
    return ApiNode().post("sales-person-client-map/billing", payload);
  },

  getActiveClientsData(payload = {}) {
    return ApiNode().post("sales-person-client-map/active-clients", payload);
  },

  getOutstandingData(payload = {}) {
    return ApiNode().post("sales-person-client-map/outstanding", payload);
  },

  getProfitLossData(payload = {}) {
    return ApiNode().post("sales-person-client-map/profit-loss", payload);
  },

  getExpenseData(payload = {}) {
    return ApiNode().post("sales-person-client-map/expenses", payload);
  },

  getTallyReverseInvoiceData(payload = {}) {
    return ApiNode().post("sales-person-client-map/tally-reverse-invoice", payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/SalesPersonTeusService.js